export default __webpack_public_path__ + "static/media/boomisland-poster.9d97e0bf.jpg";